import React from "react"
import { getSrc } from "gatsby-plugin-image"
import GGFXTransform from "./stb-jamstack-ggfxclient/module/components/ggfx-transform";
import NoImage from "../../../src/images/no-image.png"
import { useLocation } from "@reach/router";
//var strapi_url = "https://strettons-strapi.q.starberry.com";
 var strapi_url = process.env.GATSBY_STRAPI_SRC;

//export const ImageModule = (props) => {
    const ImageModule = (props) => {
        const location = useLocation();
        let isHome =false;
        if(location?.pathname === "/" && props.imagename === "articles.Modules_Add_Service_Image.service_image"){
            isHome = true;
        }
        if(props.ImageSrc && props.ImageSrc.url){

        var image_url = props.ImageSrc.url;
        if(props.ImageSrc.url_sharp){
            image_url = getSrc(props.ImageSrc.url_sharp)
        }

        let alt_text = (props.ImageSrc.alternativeText ? props.ImageSrc.alternativeText : props?.attr?.alt)+" - "+process.env.GATSBY_SITE_NAME;
        let renderer = props.renderer ? props.renderer :"srcSet";

        console.log("props ==>", props)
        return(
            <>
                {
                    (props.imagename && !isHome) ? (<>
                      <GGFXTransform mediaUrl={props.ImageSrc.url} renderer={renderer} 
                    transformConfigName={props.imagename} 
                    preResult={props?.ggfx_results} id={props.strapi_id} attr={{...props.attr, alt:alt_text}}/> </>
                    ) : (
                        <img className={props.attr.classNames} src={image_url} alt={alt_text} title={props.title} loading="lazy" />
                    )
                }
                
            </>
        )
    } else{
        return <img src={NoImage} alt="img" />;
    }
}
export default ImageModule